<template>
  <Loader v-if="isLoading" />
  <div class="container">
    <router-link to="/blogs" style="font-size: 14px">Go back</router-link>
    <p class="preview-header mb-4 mt-4">{{ this.currentBlog?.blogTitle }}</p>
    <p>
      Posted on:
      {{
        new Date(this.currentBlog?.blogDate).toLocaleString("en-us", {
          dateStyle: "long",
        })
      }}
    </p>
    <img
      :src="this.currentBlog?.blogCoverPhoto"
      class="img-fluid mb-5"
      alt=""
    />
    <div
      class="post-content ql-editor"
      v-html="this.currentBlog?.blogHTML"
    ></div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import Loader from "../components/Loader.vue";
export default {
  name: "SingleBlog",
  components: {
    Loader,
  },
  data() {
    return {
      currentBlog: null,
      isLoading: false,
    };
  },
  async created() {
    if (this.$store.state.userProfile === null) {
      this.isLoading = true;
      const postDetails = await firebase
        .firestore()
        .collection("blogPosts")
        .doc(this.$route.params.blogid)
        .get();
      this.currentBlog = postDetails.data();
      this.isLoading = false;
    } else {
      this.currentBlog = this.$store.state.blogPosts.filter((post) => {
        return post.blogID === this.$route.params.blogid;
      })[0];
    }
  },
};
</script>

<style scoped>
</style>